import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import SignUpForm from "./SignUpForm";

const styles = makeStyles(() => ({
  subTitle: {
    fontSize: 15,
    lineHeight: "23px",
    textAlign: "center",
    fontStyle: "italic",
  },
}));

const SignUpLastStep = (props) => {
  const {
    goBackStep1,
    isSubmitting,
    submit,
    clientType,
    isSignUpCompany,
    onGoogleResponse,
    onFacebookResponse,
    onAppleResponse,
    workerType
  } = props;
  const classes = styles();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <p className={classes.subTitle}>
        {t("text.pleaseProvideDetail")}
      </p>
      <Box>
        <SignUpForm
          onSubmit={submit}
          onCancel={goBackStep1}
          isSubmitting={isSubmitting}
          clientType={clientType}
          workerType={workerType}
          isSignUpCompany={isSignUpCompany}
          onGoogleResponse={onGoogleResponse}
          onFacebookResponse={onFacebookResponse}
          onAppleResponse={onAppleResponse}
        />
      </Box>
    </React.Fragment>
  );
};

SignUpLastStep.propTypes = {
  isSubmitting: PropTypes.bool,
  clientType: PropTypes.any,
  goBackStep1: PropTypes.func,
  onGoogleResponse: PropTypes.func,
  onFacebookResponse: PropTypes.func,
  onAppleResponse: PropTypes.func,
  submit: PropTypes.func,
  isSignUpCompany: PropTypes.bool,
  workerType: PropTypes.string
};

export default SignUpLastStep;
